import { cuverseApi } from 'store/api/cuverse-api/cuverse.api';

import { IChangeWalletRequestBody } from './types/change-wallet-request-body-interface';
import { IUpdateProfileRequestBody } from './types/update-profile-request-body.interface';
import { IUpdateWalletRequestBody } from './types/update-wallet-request-body.interface';
import { IWalletApproveRequestBody } from './types/wallet-approve-request-body.interface';
import { ProfileRoute } from './profile.route';

export const requestProfile = async (): Promise<unknown> =>
  cuverseApi.get(ProfileRoute.Profile()).then((res) => res?.data);

export const updateProfile = async (body: IUpdateProfileRequestBody): Promise<unknown> =>
  cuverseApi.patch(ProfileRoute.Profile(), body).then((res) => res?.data);

export const requestWallets = async (): Promise<unknown> =>
  cuverseApi.get(ProfileRoute.Wallet()).then((res) => res?.data);

export const requestWalletApprove = async (body: IWalletApproveRequestBody): Promise<unknown> =>
  cuverseApi.post(ProfileRoute.WalletApprove(), body).then((res) => res?.data);

export const updateWallet = async (body: IUpdateWalletRequestBody): Promise<unknown> =>
  cuverseApi.patch(ProfileRoute.Wallet(), body).then((res) => res?.data);

export const requestOrdersHistory = async (): Promise<unknown> =>
  cuverseApi.get(ProfileRoute.OrdersHistory()).then((res) => res);

export const requestWalletChangeFaceId = async (body: IChangeWalletRequestBody): Promise<unknown> =>
  cuverseApi.post(ProfileRoute.WalletChange(), body).then((res) => res?.data);
